<div id="wrapper">
  <p id="title">Loading...</p>

  <app-loadingcircle [hasMargin]="false"> </app-loadingcircle>
</div>
